module.exports = __webpack_public_path__ + "img/carDrivingBottom.b0edc2d0.jpg";